import { IExperiment } from '../../types/experiments';

export function getAbUseExperiment(experiments: IExperiment[], experimentName: string) {
  const experiment = experiments.find(e => e.experimentName === experimentName);

  return experiment;
}
